import { formatPrice } from "@stepapp/core";
import { Block, Button, Typography } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { AppStorage } from "../../services/AppStorage";

type Props = {
  priceDetails?: {
    currentReservationPrice?: number;
    priceDifference: number;
    newPrice?: number | null;
  };
  loading: boolean;
  isSubmitDisabled: boolean;
  buttonLabel?: string;
  handleSaveChanges: () => void;
};

const Footer = ({
  buttonLabel,
  priceDetails,
  loading,
  isSubmitDisabled,
  handleSaveChanges,
}: Props) => {
  const { t } = useTranslation();
  const priceFormatter = formatPrice(AppStorage().get("countryCode"));

  return (
    <Block justifyEnd paddingVertical={2} marginHorizontal={2.5}>
      {priceDetails && (
        <Block marginBottom={1.5}>
          <Block justifySpace row>
            <Typography variant="lightLabel">{t("screens.serviceDetails.currentPrice")}</Typography>
            <Typography variant="lightLabel">
              {priceFormatter(priceDetails?.currentReservationPrice || 0)}
            </Typography>
          </Block>
          <Block justifySpace row>
            <Typography type="error" variant="lightLabel">
              {t("screens.serviceDetails.changeDetails")}
            </Typography>
            <Typography type="error" variant="lightLabel">
              {priceDetails?.priceDifference ? priceFormatter(priceDetails?.priceDifference) : "-"}
            </Typography>
          </Block>
          <Block justifySpace row marginTop={1}>
            <Typography variant="bodyBold">{t("screens.serviceDetails.newPrice")}</Typography>
            <Typography variant="bodyBold">
              {priceDetails?.newPrice ? priceFormatter(priceDetails?.newPrice) : "-"}
            </Typography>
          </Block>
        </Block>
      )}

      <Button
        disabled={isSubmitDisabled}
        label={buttonLabel || t("common.save")}
        loading={loading}
        onPress={handleSaveChanges}
        type="primary"
        variant="default"
      />
    </Block>
  );
};

export default Footer;
